import { useState } from "react";
import { useForm } from "react-hook-form";
import { Grid } from "semantic-ui-react";
import { useGetEnergyType } from "../../../../api/common";
import {
  useGetHeatSourceType,
  useGetRefrigerantSourceType,
  useGetWaterSourceType
} from "../../../../api/static-data";
import { CommonModal, CustomButton, InputText, TitleView } from "../../../../components";
import CommonSplitContainer from "../../../../components/commonSplitContainer/CommonSplitContainer";
import MainBottomMultipleButtonView from "../../../../components/mainBottomButtonView/MainBottomMultipleButtonView";
import { DISABLE_FACILITY_SIMULATION } from "../../../../config/constants";
import FacilityEnergy from "../../facilityForms/FacilityEnergy";
import FacilityHeatSource from "../../facilityForms/FacilityHeatSource";
import FacilityRefrigerant from "../../facilityForms/FacilityRefrigerant";
import FacilityWaterSource from "../../facilityForms/FacilityWaterSource";
import FacilitySimulationModal from "../../facilitySimulation/FacilitySimulationModal";
import "../facilityDetails.scss";

interface FacilityDetailsModalLegacyProps {
  visibleModal: boolean;
  setVisibleModal: (open?: boolean) => void;
  facilityData?: any;
  countries?: any[];
  setVisibleEdit: () => void;
}

const FacilityDetailsModalLegacy = ({
  visibleModal,
  setVisibleModal,
  facilityData,
  countries,
  setVisibleEdit
}: FacilityDetailsModalLegacyProps) => {
  const [openSimulationModal, setOpenSimulationModal] = useState<boolean>(false);
  const { register } = useForm({
    values: facilityData
  });
  // fetch facility data
  const { data: energyType } = useGetEnergyType();
  const { data: refrigerantSources } = useGetRefrigerantSourceType();
  const { data: heatSources } = useGetHeatSourceType();
  const { data: waterSources } = useGetWaterSourceType();
  const energy = facilityData?.energy || [];
  const heatSource = facilityData?.heatSource || [];
  const waterSource = facilityData?.waterSource || [];
  const refrigerantSource = facilityData?.refrigerantSource || [];
  const facilityCountry = facilityData?.facilityCountry;

  const countryName = countries?.find((country: any) => country?.id === facilityCountry)?.country;

  return (
    <CommonModal
      modalOpenState={visibleModal}
      modalCloseState={() => setVisibleModal(false)}
      centered={true}
      title={facilityData?.facilityName}
    >
      <Grid>
        <Grid.Column computer={16} tablet={16} mobile={16}>
          <CommonSplitContainer
            currentHeight={0.91}
            topChild={
              <>
                <Grid>
                  {!DISABLE_FACILITY_SIMULATION && (
                    <Grid.Column computer={16} tablet={16} mobile={16} textAlign="right">
                      <CustomButton
                        theme="green"
                        title="Simulation"
                        buttonOutLine={false}
                        onClick={() => {
                          setOpenSimulationModal(true);
                        }}
                      />
                    </Grid.Column>
                  )}
                  <TitleView title="Facility Info" />
                  <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                    <InputText
                      register={register}
                      labelName={"Facility Name*"}
                      placeholder="Facility Name"
                      name="facilityName"
                      disabled={true}
                    />
                  </Grid.Column>
                  <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                    <InputText
                      register={register}
                      labelName={"Facility Ownership*"}
                      placeholder="Facility Ownership"
                      name="facilityOwnership"
                      disabled={true}
                    />
                  </Grid.Column>
                  <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                    <InputText
                      register={register}
                      labelName={"Facility Type*"}
                      placeholder="Facility Type"
                      name="facilityType"
                      disabled={true}
                    />
                  </Grid.Column>
                  <Grid.Column computer={8} tablet={16} mobile={16} className="paddingRemoveBottom">
                    <InputText
                      register={register}
                      labelName={"Address"}
                      placeholder="Address"
                      name="facilityAddress"
                      disabled={true}
                    />
                  </Grid.Column>
                  <Grid.Column computer={8} tablet={16} mobile={16} className="mb-1">
                    <InputText
                      register={register}
                      labelName={"City"}
                      placeholder="City"
                      name="facilityCity"
                      disabled={true}
                    />
                  </Grid.Column>
                  <Grid.Column computer={8} tablet={16} mobile={16} className="mb-1">
                    <InputText labelName={"Country*"} placeholder={countryName} disabled={true} />
                  </Grid.Column>
                </Grid>
                <FacilityEnergy
                  energyType={energyType}
                  renderTableData
                  addFacilityEnergy={energy || []}
                  currentFacilityData={energy || []}
                />
                <FacilityHeatSource
                  heatType={heatSources}
                  renderTableData
                  addFacilityHeat={heatSource}
                  currentFacilityHeatData={heatSource || []}
                />
                <FacilityWaterSource
                  waterType={waterSources}
                  renderTableData
                  addFacilityWater={waterSource}
                  currentFacilityWaterData={waterSource || []}
                />
                <FacilityRefrigerant
                  refrigerantType={refrigerantSources}
                  renderTableData
                  addFacilityRefrigerant={refrigerantSource}
                  currentFacilityRefrigerantData={refrigerantSource || []}
                />
                {openSimulationModal && (
                  <FacilitySimulationModal
                    visibleModal={openSimulationModal}
                    onClose={() => setOpenSimulationModal(false)}
                    facilityData={facilityData}
                  />
                )}
              </>
            }
            bottomChild={
              <MainBottomMultipleButtonView
                leftButtons={[
                  {
                    title: "Cancel",
                    onClick: () => setVisibleModal(false),
                    buttonOutLine: true
                  }
                ]}
                rightButtons={[
                  {
                    contentView: 16,
                    title: "Edit",
                    onClick: () => {
                      setVisibleEdit();
                    },
                    buttonView: true
                  }
                ]}
              />
            }
          />
        </Grid.Column>
      </Grid>
    </CommonModal>
  );
};

export default FacilityDetailsModalLegacy;
export type { FacilityDetailsModalLegacyProps };
